export default __webpack_public_path__ + "static/media/msf_xl3.75559df2.png";